const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev',
  IMAGE_PATH: '/images/small/',
  DEFAULT_LANGUAGE: 'en-us',
  CACHE_NAME: 'yowes-catalog',
  DATABASE_NAME: 'yowes-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurant',
};

export default CONFIG;
